import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const createQuestionnaireMutation = gql`
  mutation createQuestionnaire($input: CreateQuestionnaireInput!) {
    createQuestionnaire(input: $input) {
      data {
        surface {
          id
        }
        questions {
          id
        }
      }
      error
      success
    }
  }
`;

// createQuestionnaire(input:{
//   surface:"64f99f061d714eef8169a3ede7c623a2"
//   questions:[
//     {required: true
//       question: "How is it goin?"
//       type: text
//     }
//      {required: true
//       question: "How is it goin22?"
//       type: text
//     }

//   ]

// }){
//   data{
//     # id
//     surface{id}
//     questions{
//       id
//     }
//   }
// }
// }

export default mutation(createQuestionnaireMutation);
